import { Box, CardMedia, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EmptyState from './../../../assets/empty_state.svg';

export const NoAuthPlaceholder = () => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <CardMedia
        image={EmptyState}
        sx={{ minHeight: '267px', minWidth: '400px' }}
      />
      <Typography variant="body1" className="text-center font-bold leading-6">
        {t('authenticationIssueTitle')}
      </Typography>
      <Typography variant="body2" className="text-center mt-2 max-w-[360px]">
        {t('authenticationIssueMessage')}
      </Typography>
    </Box>
  );
};
